import React from 'react';

export interface Tab {
  id: string;
  label: string;
  isActive: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
  onTabClick: (tabId: string) => void;
  className?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  onTabClick,
  className = ''
}) => (
  <div className={`w-fit border-b-2 border-grey10 ${className}`}>
    <div className="flex w-fit items-center">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabClick(tab.id)}
          className={`
            relative flex h-9 w-[129px] shrink-0 items-center justify-center text-sm font-medium transition-all duration-200

            ${tab.isActive ? 'text-cofeePrimary6' : 'text-content'}
          `}
        >
          <span className="font-['DM_Sans']">{tab.label}</span>
          {tab.isActive && (
            <div className="absolute inset-x-0 bottom-0 h-0.5 bg-cofeePrimary6" />
          )}
        </button>
      ))}
    </div>
  </div>
);

export default TabNavigation;
